import { ForecastRatioCurveTypeBase } from './base/forecast-ratio-curve-type-base';

export class ForecastRatioCurveType extends ForecastRatioCurveTypeBase { }